import React from 'react';
import {
    ServiceP,
    ServicesCard,
    ServicesContainer,
    ServicesH1,
    ServicesH2,
    ThreeWrapper, WhiteH1
} from "./FormsElements";
import {
    CardYoutubeWrap,
    InfoContainer
} from "../InfoSection/InfoElements";

const FormsPayrollDetails = () => {
    return (
        <>
        <ServicesContainer id='formspayroll'>
            <ServicesH1>Payroll Forms</ServicesH1>
            <ThreeWrapper>
                <ServicesCard>
                    <ServicesH2>Form 941</ServicesH2>
                    <ServiceP>Employer’s QUARTERLY Federal Tax Return</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 940</ServicesH2>
                    <ServiceP>Employer's Annual Federal Unemployment (FUTA) Tax Return
                    </ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 943</ServicesH2>
                    <ServiceP>Employer’s Annual Federal Tax Return for Agricultural Employees</ServiceP>
                </ServicesCard>
            </ThreeWrapper>
            <ThreeWrapper>
                <ServicesCard>
                    <ServicesH2>Form 944</ServicesH2>
                    <ServiceP>Employer’s ANNUAL Federal Tax Return</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 945</ServicesH2>
                    <ServiceP>Annual Return of Withheld Federal Income Tax
                    </ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Formulario 941-PR</ServicesH2>
                    <ServiceP>Planilla para la Declaración Federal TRIMESTRAL del Patrono</ServiceP>
                </ServicesCard>
            </ThreeWrapper>
            <ThreeWrapper>
                <ServicesCard>
                    <ServicesH2>Form 941-SS</ServicesH2>
                    <ServiceP>Employer’s QUARTERLY Federal Tax Return</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 945</ServicesH2>
                    <ServiceP>Annual Return of Withheld Federal Income Tax
                    </ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 941-X</ServicesH2>
                    <ServiceP>Adjusted Employer’s QUARTERLY Federal Tax Return or Claim for Refund</ServiceP>
                </ServicesCard>
            </ThreeWrapper>
        </ServicesContainer>
            <InfoContainer lightBg={false} >
                <ServicesContainer>
                    <WhiteH1>How to E-file 941 Form Online</WhiteH1>
                    <CardYoutubeWrap>
                        <iframe width="100%" height="110%" src="https://www.youtube.com/embed/gfOxwE05fdU" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    </CardYoutubeWrap>
                </ServicesContainer>
            </InfoContainer>
        </>
    );
};

export default FormsPayrollDetails;
